module.exports = __webpack_public_path__ + "img/working_on_oncloud.e345f159.png";